<a class="nav-item expandable">
  <button mat-button class="nav-expandable-button" (click)="toggleCollapsed()">
    <div class="content">
      <div class="flex items-center">
        <mat-icon aria-hidden="false" aria-label="Example home icon">{{link?.icon}}</mat-icon>
        <span class="ml-6">{{link?.name}}</span>
      </div>
      <mat-icon aria-hidden="false" aria-label="Example home icon">chevron_right</mat-icon>
    </div>
  </button>
  <div *ngIf="!collapsed" class="submenu">
    <div *ngFor="let child of link?.children">
      <a *ngIf="!child.comingSoon" class="nav-item" [routerLink]="child.path" routerLinkActive="active">
        <button mat-button class="nav-button">
          <div class="content flex items-center">
            <mat-icon aria-hidden="false" class="ml-1" aria-label="Example home icon">
              {{child.icon}}
            </mat-icon>
            <span class="ml-6">
              {{child.name}}
            </span>
          </div>
        </button>
      </a>
      <a *ngIf="child.comingSoon" class="nav-item">
        <button mat-button class="nav-button">
          <div class="content flex items-center">
            <mat-icon aria-hidden="false" class="ml-1" aria-label="Example home icon">
              {{child.icon}}
            </mat-icon>
            <span class="ml-6">
              {{child.name}}
            </span>
            <div class="bg-primary ml-4 px-4 py-0 text-white rounded-lg text-xs content-center">Coming Soon</div>
          </div>
        </button>
      </a>
    </div>
  </div>
</a>
